/*
 * Banner consenso cookie, mostrato solo se il noleggio ha un container GTM attivo.
 * Regole (linee guida Garante privacy): "Rifiuta" con la stessa evidenza di "Accetta",
 * la X equivale a rifiuto, nessun cookie wall, scelta modificabile dal footer.
 */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Checkbox, Icon, Modal } from "semantic-ui-react";
import { applyConsent, readConsent, writeConsent } from "../../utils/consent";

const CookieConsent = ({
  open,
  codiceNoleggio,
  denominazione,
  testoPrivacy,
  onDone,
  t,
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  // All'apertura riparto dall'eventuale scelta gia' salvata
  useEffect(() => {
    if (!open) return;
    const stored = readConsent(codiceNoleggio);
    setAnalytics(stored ? stored.analytics : false);
    setMarketing(stored ? stored.marketing : false);
    setShowDetails(!!stored);
  }, [open, codiceNoleggio]);

  if (!open) return null;

  const save = (consent) => {
    writeConsent(codiceNoleggio, consent);
    applyConsent(consent);
    onDone();
  };

  const acceptAll = () => save({ analytics: true, marketing: true });
  const rejectAll = () => save({ analytics: false, marketing: false });
  const saveChoice = () => save({ analytics, marketing });

  return (
    <div
      className="ns-cookie-consent"
      role="dialog"
      aria-live="polite"
      aria-label={t("cookie_titolo")}
    >
      <button
        type="button"
        className="ns-cookie-consent_close"
        aria-label={t("cookie_chiudi_rifiuta")}
        title={t("cookie_chiudi_rifiuta")}
        onClick={rejectAll}
      >
        <Icon name="close" />
      </button>

      <h4 className="ns-cookie-consent_title">{t("cookie_titolo")}</h4>
      <p className="ns-cookie-consent_text">
        {t("cookie_testo", { denominazione: denominazione || "" })}{" "}
        {testoPrivacy && (
          <button
            type="button"
            className="ns-cookie-consent_link"
            onClick={() => setShowPrivacy(true)}
          >
            {t("informativa_privacy")}
          </button>
        )}
      </p>

      {showDetails && (
        <div className="ns-cookie-consent_details">
          <div className="ns-cookie-consent_category">
            <Checkbox toggle checked disabled label={t("cookie_necessari")} />
            <p>{t("cookie_necessari_desc")}</p>
          </div>
          <div className="ns-cookie-consent_category">
            <Checkbox
              toggle
              checked={analytics}
              onChange={(e, { checked }) => setAnalytics(checked)}
              label={t("cookie_analitici")}
            />
            <p>{t("cookie_analitici_desc")}</p>
          </div>
          <div className="ns-cookie-consent_category">
            <Checkbox
              toggle
              checked={marketing}
              onChange={(e, { checked }) => setMarketing(checked)}
              label={t("cookie_marketing")}
            />
            <p>{t("cookie_marketing_desc")}</p>
          </div>
        </div>
      )}

      <div className="ns-cookie-consent_actions">
        {showDetails ? (
          <Button basic onClick={saveChoice}>
            {t("cookie_salva")}
          </Button>
        ) : (
          <Button basic onClick={() => setShowDetails(true)}>
            {t("cookie_personalizza")}
          </Button>
        )}
        {/* Rifiuta e Accetta con la stessa evidenza grafica */}
        <Button primary onClick={rejectAll}>
          {t("cookie_rifiuta")}
        </Button>
        <Button primary onClick={acceptAll}>
          {t("cookie_accetta_tutti")}
        </Button>
      </div>

      <Modal open={showPrivacy} onClose={() => setShowPrivacy(false)}>
        <Modal.Header>
          <Icon name="info" size="large" color="blue" />
          {t("informativa_privacy")}
        </Modal.Header>
        <Modal.Content dangerouslySetInnerHTML={{ __html: testoPrivacy }} />
        <Modal.Actions>
          <Button primary onClick={() => setShowPrivacy(false)}>
            Ok
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

CookieConsent.propTypes = {
  open: PropTypes.bool.isRequired,
  codiceNoleggio: PropTypes.string,
  denominazione: PropTypes.string,
  testoPrivacy: PropTypes.string,
  onDone: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default CookieConsent;
